<template>
  <div>
    <b-navbar toggleable="lg" type="primary" variant="light" class="top-style">
      <b-nav-text class="custom-phone">客服电话：0791-86373703</b-nav-text>

      <b-navbar-toggle target="nav-collapse-top" class="top-style"></b-navbar-toggle>

      <b-collapse id="nav-collapse-top" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item :href="$ADMIN_URL + '/#/user-guide'" target="user_help">用户使用手册</b-nav-item>

          <b-nav-item-dropdown text="关注公众号" right>
            <b-dropdown-item href="#">
              <b-img :src="jyhQrcode" width="180px" height="180px"></b-img>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :href="$ADMIN_URL" target="admin_window">登录</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-navbar toggleable="lg" type="primary" variant="">
      <b-navbar-brand href="#">
        <b-img :src="jyhLogo" width="120px" height="41px"></b-img>
        人才服务网
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/">首页</b-nav-item>
          <b-nav-item to="/search-job">
            <div>求职</div>
          </b-nav-item>
          <b-nav-item :to="{name: 'InfoMain'}">
            <div>就业资讯</div>
          </b-nav-item>
          <b-nav-item href="/meeting">招聘会<!--b-badge variant="danger" pill class="right-badge">前往</b-badge--></b-nav-item>
          <b-nav-item href="#">教师资格</b-nav-item>
          <b-nav-item href="#">就业质量调查</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import JyhLogo from '@/assets/jyh-logo-color.png'
import JyhQrcode from '@/assets/jyh-qrcode.jpg'

export default {
  name: 'NavBar',
  data() {
    return {
      jyhLogo: JyhLogo,
      jyhQrcode: JyhQrcode
    }
  }
}
</script>

<style lang="scss" scoped>
.top-style {
  height: 30px;
  font-size: 14px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.custom-phone {
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 12px;
}
.right-badge {
  vertical-align: super;
  font-size: 10px;
}
</style>
